import * as Yup from 'yup';
import createCategoriaCotizacionFormModel from './createCategoriaCotizacionFormModel';

const {
  formField: { name, description },
} = createCategoriaCotizacionFormModel;

export default [
  Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),
  }),
];
